
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"7","viewBox":"0 0 9 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.664062 4.3974L2.30509 5.9974L7.77517 0.664062","stroke":"currentColor","stroke-width":"1.33","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    